import { render, staticRenderFns } from "./BlogContent.vue?vue&type=template&id=3f1f0f22&scoped=true"
import script from "./BlogContent.vue?vue&type=script&lang=js"
export * from "./BlogContent.vue?vue&type=script&lang=js"
import style0 from "./BlogContent.vue?vue&type=style&index=0&id=3f1f0f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f0f22",
  null
  
)

export default component.exports